import {axiosService} from "./axios.service";
import {endPoints} from "../configs/urls";

const servicePackagesService = {
    getAll: async () => {
        try {
            const res = await axiosService.get(endPoints.servicePackages.base);

            return res;
        } catch (error) {
            throw error;
        }
    }
}

export {
    servicePackagesService
}
